import {
    APIJobFeedbackMessageModel,
    APIJobListParams
} from "../Models/API/JobModel"
import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList, getPageToFetch } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getJobFeedbackMessageList } from "../Actions/API/Job/JobActions"

export function useJobFeedbackMessageList(
    appID: string,
    {
        params,
        refetchOnStale
    }: {
        params: APIJobListParams
        /**
         * Trigger fetch as soon as page becomes stale
         */
        refetchOnStale: boolean
    }
): FetchState<{
    items: APIJobFeedbackMessageModel[]
    total: number
}> {
    const dispatch = useDispatch()
    const entry = useAppState(state => state.api.jobs.messageTable[appID])

    useEffect(() => {
        const page = getPageToFetch(entry, params, refetchOnStale)

        if (page >= 0) {
            dispatch(getJobFeedbackMessageList(appID, params, page))
        }
    }, [dispatch, params, appID, entry, refetchOnStale])

    return useMemo(() => {
        if (
            entry === undefined ||
            entry.list === undefined ||
            JSON.stringify(entry.list.params) !== JSON.stringify(params)
        ) {
            return undefined
        }

        return Result.ok({
            items: getItemList(entry),
            total: entry.list.total
        })
    }, [entry, params])
}
